import { useState } from "react";
import ThirdPartyLayout from "../ThirdPartyLayout";
import {
  RazorButton,
  RazorNumberFormat,
} from "../../../../components/razor-reuse";
import CurrencyText from "../../../../components/fragment/cur-text/CurrencyText";
import { useSelector } from "react-redux";
import RootState from "../../../../redux/type";
import "../../../../styles/dashboard/third-party/ThirdPartyIndex.css";
import { ALL_ICONS } from "../../../../assets/icons/AllIcons";
import AccountDetailsModal from "./AccountDetailsModal";

const PayazaIndex = () => {
  const { all_currencies_drop } = useSelector(
    (state: RootState) => state.settings
  );
  const { loading, payaza, third_party_info } = useSelector(
    (state: RootState) => state.thirdParty
  );

  type showModalProps = {
    view: boolean;
  };
  const [showModal, setShowModal] = useState<showModalProps>({
    view: false,
  });
  const [currencyView, setCurrencyView] = useState<any>({
    label: "NGN",
    value: "NGN",
    donT_send: true,
  });

  const [filterOneVal, setFilterOneVal] = useState<any>("");
  const removeSelectedList = (list: any) => {
    if (list?.length > 0) {
      const newlist = list?.filter(
        (chi: any) => chi?.label !== filterOneVal?.label
      );
      //   const secondlist = newlist?.filter(
      //     (chi: any) => chi?.label !== filterTwoVal?.label
      //   );
      return newlist;
    }
  };

  const formatOptionLabelCurrency = ({ label, value }: any) => {
    if (value === "") {
      return label;
    } else {
      return (
        <>
          <CurrencyText currency={label} text={label} />
        </>
      );
    }
  };

  const formatCurrencyValList = (list: any) => {
    const newList = list?.filter(
      (chi: any) => chi?.label !== currencyView?.label
    );
    // const
    return newList;
  };

  const accountList = [
    {
      name: "Available Balance",
      amount: RazorNumberFormat(payaza?.accountBalance, {
        symbol: payaza?.currency,
      }),
      bottomBg: "#DACCE0",
      gradientBg:
        "linear-gradient( to bottom right, #350051 0%, #550780 50%, #000000 100% )",
      btn_text: "Fund Account",
    },
    // {
    //   name: "Total Outflow",
    //   amount: "NGN 500,000",
    //   bottomBg: "#BDDBD9",
    //   gradientBg:
    //     "linear-gradient( to bottom right, #123834 0%, #123834 60%, #000000 90% )",
    // },
    // {
    //   name: "Total Inflow",
    //   amount: "NGN 100,000,000",
    //   bottomBg: "#BFE2ED",
    //   gradientBg:
    //     "linear-gradient(to bottom right,#122E37 0%,#122E37 60%,#000000 90%)",
    // },
  ];

  return (
    <>
      <ThirdPartyLayout
        pageLoading={loading && Object.keys(third_party_info)?.length < 1}
        titleText="Here are the details about your payaza account"
        title="Payaza Account"
        // titleSelectComp={
        //   <RazorInputField
        //     selectOption={formatCurrencyValList(all_currencies_drop)}
        //     type="select"
        //     color="black-light"
        //     className="select-title-wrap"
        //     style={{ padding: ".4rem 1.6rem" }}
        //     value={currencyView}
        //     onChange={(e: any) => {
        //       setCurrencyView(e);
        //       //   setFilterTwoVal("");
        //     }}
        //     selectStyles={reactSelectStyleTable}
        //     formatOptionLabel={formatOptionLabelCurrency}
        //     // selectMenuOpen={true}
        //   />
        // }
      >
        <div
          //   onClick={() => {
          //     console.log(payaza);
          //   }}
          className="payaza-index-wrapper-box-third-party"
        >
          {accountList?.map((chi, idx) => {
            return (
              <div key={idx} className="card-amount-box">
                {/* top box start */}
                <div
                  style={{ background: chi?.gradientBg ? chi?.gradientBg : "" }}
                  className="top-box"
                >
                  <div className="label-value-box">
                    <p className="label">{chi?.name}</p>
                    <p className="value">
                      {RazorNumberFormat(chi?.amount, {
                        symbol: currencyView?.label,
                      })}
                    </p>
                  </div>
                  {chi?.btn_text && (
                    <div className="btn-box">
                      <RazorButton
                        onClick={() => {
                          setShowModal((prev) => {
                            return { ...prev, view: true };
                          });
                        }}
                        className="btn-fund"
                        color="black-light"
                      >
                        <figure className="img-box">
                          {ALL_ICONS?.fund_icon_payaza}
                        </figure>
                        <p className="text">{chi?.btn_text}</p>
                      </RazorButton>
                    </div>
                  )}
                </div>
                {/* top box end */}
                {/* bottom box start */}
                <div
                  style={{ backgroundColor: chi?.bottomBg }}
                  className="bottom-box"
                ></div>
                {/* bottom box end */}
              </div>
            );
          })}
        </div>
      </ThirdPartyLayout>
      {/* modal start */}
      <AccountDetailsModal
        visible={showModal?.view}
        onClose={() => {
          setShowModal((prev) => {
            return { ...prev, view: false };
          });
        }}
      />
      {/* modal end */}
    </>
  );
};

export default PayazaIndex;
